module.exports = "https://cdn.thelire.com/ins/resource/ico_coinstore_vippackages@3x.13a86fc0b0cae1cedd33a500a3dce0e7.png";